export default class PDPGalleryModal extends HTMLElement {
  dialog: HTMLDialogElement | null = null;
  overlay: HTMLDivElement | null = null;
  panel: HTMLDivElement | null = null;

  connectedCallback() {
    this.dialog = this.querySelector('[id*="-dialog"]');
    this.overlay = this.querySelector('[id*="-overlay"]');
    this.panel = this.querySelector('[id*="-panel"]');

    const closeBtns = this.querySelectorAll('[data-gallery-modal-close]');

    closeBtns.forEach((btn) => {
      btn.addEventListener('click', this.close.bind(this));
    });

    this.overlay?.addEventListener('click', this.close.bind(this));

    // Intercept native Escape close
    this.dialog?.addEventListener('cancel', (e) => {
      e.preventDefault(); // stop auto-close
      this.close(); // use animated version
    });
  }

  show() {
    window.scrollLock();
    this.dialog?.showModal();
  }

  close() {
    this.dialog?.close();
    window.scrollUnlock();
  }
}

if (!customElements.get('pdp-gallery-modal')) {
  customElements.define('pdp-gallery-modal', PDPGalleryModal);
}
